<template>
  <div id="report-choice">
    <div class="conditional">
      <dashboard-button v-if="showSafetyObservations" url="/ObservNow" />
      <dashboard-button
        v-if="showIncidentManagement"
        label="Incident or Near Miss"
      >
        <template #icon>
          <svg
            width="48"
            height="48"
            viewBox="0 0 66 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.1429 7.125H9.42857C4.22132 7.125 0 11.3783 0 16.625V66.5C0 71.7467 4.22132 76 9.42857 76H56.5714C61.7787 76 66 71.7467 66 66.5V16.625C66 11.3783 61.7787 7.125 56.5714 7.125H51.8571V11.875H56.5714C59.1751 11.875 61.2857 14.0016 61.2857 16.625V66.5C61.2857 69.1234 59.1751 71.25 56.5714 71.25H9.42857C6.82494 71.25 4.71429 69.1234 4.71429 66.5V16.625C4.71429 14.0016 6.82494 11.875 9.42857 11.875H14.1429V7.125Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M40.0714 4.75H25.9286C24.6268 4.75 23.5714 5.81332 23.5714 7.125V11.875C23.5714 13.1867 24.6268 14.25 25.9286 14.25H40.0714C41.3732 14.25 42.4286 13.1867 42.4286 11.875V7.125C42.4286 5.81332 41.3732 4.75 40.0714 4.75ZM25.9286 0C22.0231 0 18.8571 3.18997 18.8571 7.125V11.875C18.8571 15.81 22.0231 19 25.9286 19H40.0714C43.9769 19 47.1429 15.81 47.1429 11.875V7.125C47.1429 3.18997 43.9769 0 40.0714 0H25.9286Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 58.875C16 57.5633 17.0633 56.5 18.375 56.5H32.625C33.9367 56.5 35 57.5633 35 58.875C35 60.1867 33.9367 61.25 32.625 61.25H18.375C17.0633 61.25 16 60.1867 16 58.875Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 49.375C16 48.0633 17.0633 47 18.375 47H46.875C48.1867 47 49.25 48.0633 49.25 49.375C49.25 50.6867 48.1867 51.75 46.875 51.75H18.375C17.0633 51.75 16 50.6867 16 49.375Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 39.875C16 38.5633 17.0633 37.5 18.375 37.5H46.875C48.1867 37.5 49.25 38.5633 49.25 39.875C49.25 41.1867 48.1867 42.25 46.875 42.25H18.375C17.0633 42.25 16 41.1867 16 39.875Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 30.375C16 29.0633 17.0633 28 18.375 28H46.875C48.1867 28 49.25 29.0633 49.25 30.375C49.25 31.6867 48.1867 32.75 46.875 32.75H18.375C17.0633 32.75 16 31.6867 16 30.375Z"
              fill="black"
            />
          </svg>
        </template>
      </dashboard-button>
      <dashboard-button
        v-if="showKnowledgeBase"
        label="Visit Knowledge Base"
        url="/zendesk-knowledge-base?source=homepage"
        target="_blank"
        linkclass="knowledge-base"
      >
        <template #icon>
          <div>
            <svg
              id="knowledge-base-icon"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="18 0 102 171"
              width="76"
              height="120"
            >
              <g>
                <path
                  class="bulb"
                  d="M68.31,74.9c-3.69,0-7.37,0-11.06.01-.38,0-.54-.11-.69-.45-1.37-3.04-3.26-5.73-5.53-8.18-4.72-5.08-6.9-11.13-6.43-18.04.74-10.96,9.1-20.02,19.97-21.8,12.6-2.07,24.73,6.31,27.11,18.84,1.55,8.13-.62,15.25-6.29,21.28-2.21,2.35-4.03,4.94-5.33,7.88-.16.37-.35.48-.74.48-3.67-.02-7.33,0-11,0Z"
                />
                <path
                  class="cls-6"
                  d="M57.43,80.09c.24,1.23.62,1.84.86,3.02h18.89c.23-1.22.3-1.82.53-3.02h-20.27Z"
                />
                <path
                  class="cls-6"
                  d="M58.61,87.13c0,.62-.03.62,0,1.19.06,1.03.91,1.86,1.96,1.86,4.86.01,9.71,0,14.57,0,.97,0,1.78-.64,1.92-1.61.1-.65.02-.75.02-1.44h-18.47Z"
                />
                <path
                  class="cls-6"
                  d="M65.4,92.95c-.11,0-.23.01-.37.02-.12,1.16.2,2.1,1.16,2.75.87.58,1.98.56,2.85-.04.87-.6,1.26-1.63,1.03-2.74-1.55,0-3.11,0-4.67,0Z"
                />
              </g>
              <text
                class="cls-4"
                transform="translate(50.01 66.06) scale(1.27 1)"
              >
                <tspan class="cls-5" x="9.12" y="0">i</tspan>
              </text>
            </svg>
          </div>
        </template>
      </dashboard-button>
      <dashboard-button
        v-if="showProtocols"
        label="View Protocols &amp; SOPs"
        :url="protocolsUrl"
        target="_blank"
        linkclass="protocols"
      >
        <template #icon>
          <div>
            <svg
              width="48"
              id="protocols-icon"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M40 13V10C40 9.20435 39.6839 8.44129 39.1213 7.87868C38.5587 7.31607 37.7956 7 37 7H29"
                stroke="#073B53"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 7H4C3.20435 7 2.44129 7.31607 1.87868 7.87868C1.31607 8.44129 1 9.20435 1 10V43C1 43.7956 1.31607 44.5587 1.87868 45.1213C2.44129 45.6839 3.20435 46 4 46H11.5"
                stroke="#073B53"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M28.3417 8.97401C28.242 9.27241 28.0511 9.53197 27.796 9.71605C27.5408 9.90014 27.2343 9.99947 26.9197 10H14.0817C13.7668 9.99988 13.4598 9.90076 13.2043 9.71664C12.9487 9.53252 12.7575 9.27273 12.6577 8.97401L10.6577 2.974C10.5821 2.74846 10.5613 2.50816 10.5971 2.27298C10.6328 2.03781 10.724 1.81453 10.8632 1.62161C11.0024 1.42869 11.1855 1.27169 11.3974 1.1636C11.6093 1.0555 11.8438 0.999426 12.0817 1H28.9177C29.1556 0.999426 29.3902 1.0555 29.6021 1.1636C29.814 1.27169 29.9971 1.42869 30.1362 1.62161C30.2754 1.81453 30.3666 2.03781 30.4024 2.27298C30.4381 2.50816 30.4173 2.74846 30.3417 2.974L28.3417 8.97401Z"
                stroke="#073B53"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13 40H8.5C8.10218 40 7.72064 39.842 7.43934 39.5607C7.15804 39.2794 7 38.8978 7 38.5V13"
                stroke="#073B53"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M31.0039 14.5V19"
                stroke="#073B53"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13 19H22"
                stroke="#073B53"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13 28H16"
                stroke="#073B53"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M25.59 44.94L18.166 46L19.226 38.576L38.318 19.484C39.1619 18.6401 40.3065 18.166 41.5 18.166C42.6935 18.166 43.8381 18.6401 44.682 19.484C45.5259 20.3279 46 21.4725 46 22.666C46 23.8595 45.5259 25.0041 44.682 25.848L25.59 44.94Z"
                fill="#00A1A2"
                fill-opacity="0.15"
                stroke="#00A1A2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </template>
      </dashboard-button>
    </div>
  </div>
</template>

<script>
import { useNotification } from "@/composables/useNotification";
import { restClient } from "@/lib/raftApi";
import { useModulesEnabled } from "@/composables/useModulesEnabled";
import DashboardButton from "./DashboardButton.vue";

const { showNotification } = useNotification();

export default {
  name: "ReportChoice",
  components: { DashboardButton },
  data() {
    return {
      showIncidentManagement: false,
      showProtocols: false,
      showSafetyObservations: false,
      showKnowledgeBase: false,
      elabnextEndpoint: "",
    };
  },
  computed: {
    protocolsUrl() {
      return this.elabnextEndpoint + "/members/protocols";
    },
  },
  setup() {
    const { modulesEnabled, getModules } = useModulesEnabled();
    return {
      modulesEnabled,
      getModules,
    };
  },
  methods: {
    async getConfig() {
      const response = await restClient.get({
        path: "configuration/scisure_integration.elabnext",
        queries: {},
      });
      if (response?.elabnext_host) {
        this.elabnextEndpoint = response?.elabnext_host;
      }
      if (response?.enable_sops_block) {
        this.showProtocols = true;
      }
    },
  },
  async created() {
    try {
      await this.getModules();
      this.showSafetyObservations = this.modulesEnabled?.safety_observations;
      this.showIncidentManagement = this.modulesEnabled?.incident_management;
      this.showKnowledgeBase = this.modulesEnabled?.knowledge_base;
    } catch (exception) {
      showNotification({
        message: "An error has occurred. Please try again later.",
        type: "error",
      });
    }
    if (this.modulesEnabled?.scisure_integration) {
      await this.getConfig();
    }
    this.isReady = true;
  },
};
</script>

<style scoped>
#report-choice-h1 {
  margin: 0;
  padding: 0 0 0.25rem 0;
  font-size: 0.875rem;
}

div.conditional {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

@media only screen and (max-width: 60rem) {
  div.conditional {
    flex-direction: column;
  }
}

div.conditional > a {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--hx-border__color, #dce4e7);
  background: #f7f9fc;
  color: var(--hx-text-primary, #141414);
  width: 11.25rem;
  height: 7.8125rem;
  border-radius: 0.4rem;
  font-family: helvetica, arial, sans-serif;
  text-decoration: none;
  gap: 1rem;
  margin: 1rem 0.5rem;
  padding: 0.75rem;
  font-size: 1.3rem;
}

div.conditional > a:hover {
  color: #141414;
  background-color: #f8fbff;
  border-color: #00abab;
}

div.full-height-centered-flex-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#knowledge-base-icon {
  margin-bottom: -2em;
  margin-top: -1em;
}

#knowledge-base-icon .bulb {
  fill: none;
  stroke: #000;
  stroke-miterlimit: 10;
  stroke-width: 0.16rem;
}

#knowledge-base-icon .cls-4 {
  font-size: 2.6875rem;
}

#knowledge-base-icon .cls-6 {
  stroke-width: 0;
}
</style>
